import {
  CLEAR_SEARCH_CUSTOMERS,
  SEARCH_CUSTOMERS,
  SEARCH_CUSTOMERS_FULFILLED,
  SEARCH_CUSTOMERS_REJECTED,
} from './types';

export function searchCustomers(value, options) {
  return {
    type: SEARCH_CUSTOMERS,
    payload: {
      value,
      options,
    },
  };
}

export function searchCustomersFulfilled(customersSearchResults) {
  return {
    type: SEARCH_CUSTOMERS_FULFILLED,
    payload: {
      searchResults: customersSearchResults,
    },
  };
}

export function searchCustomersRejected(error) {
  return {
    type: SEARCH_CUSTOMERS_REJECTED,
    payload: error,
  };
}

export function clearCustomersSearch() {
  return {
    type: CLEAR_SEARCH_CUSTOMERS,
  };
}
